import { gql } from "@apollo/client";

export const FETCH_COMMERCAIL_TOTAL_USER = gql`
   query GetCommercialUserTotals($from_date:Time, $to_date:Time) {
    getCommercialUserTotals(from_date: $from_date, to_date: $to_date) {
        error
        data {
            total_all
            total_active
            total_inactive
            total_new
            }
        }
    }
`;

export const FETCH_MEMBERSHIP_COUNT = gql`
   query FetchMembershipCount {
    fetchMembershipCount {
        data {
            standard_user_count
            total_count
            basic_user_count
            premium_user_count
        }
        error {
            message
            code
            field
        }
    }
}
`;